import React, { FC } from 'react'
import type { CSSProperties } from 'react'
import './Core.css'
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner'

interface LoadingScreenProps {
  children?: React.ReactNode
  width?: number
  height?: number
}

export const LoadingScreen: FC<LoadingScreenProps> = ({ children, width, height }) => {
  return (
    <div
      className="pdf-core__loading-container"
      style={
        {
          '--lc-width': width ? `${width}px` : undefined,
          '--lc-height': height ? `${height}px` : undefined,
        } as CSSProperties
      }
    >
      <LoadingSpinner>{children && children}</LoadingSpinner>
    </div>
  )
}
